import { types } from './configuracaoBoleto.actions'
import { Reducer } from '../../services/reducer.factory'
import storage from '../../services/stoage.service'

const initialState = {
  id: 'configuracaoBoleto',
  booleanFilter: { tipoBoleto: [] },
  filterValues: {},
  showHideColumns: [
    {
      label: 'Código',
      value: {
        field: 'oid',
        header: 'Código',
        columnKey: 'oid',
        sortable: true,
        filter: true,
        columnSortField: 'oid',
        visible: true,
      },
    },
    {
      label: 'Nome',
      value: {
        field: 'nome',
        header: 'Nome',
        columnKey: 'nome',
        sortable: true,
        filter: true,
        visible: true,
      },
    },
    {
      label: 'Tipo Boleto',
      value: {
        field: 'tipoBoleto',
        header: 'Tipo Boleto',
        columnKey: 'tipoBoleto',
        columnSortField: 'tipoBoleto',
        sortable: true,
        filter: true,
        visible: true,
      },
    },
  ],
  columnsLookup: [
    {
      field: 'oid',
      header: 'Código',
      columnKey: 'oid',
      sortable: true,
      filter: true,
      columnSortField: 'oid',
      visible: true,
    },
    {
      field: 'nome',
      header: 'Nome',
      columnKey: 'nome',
      sortable: true,
      filter: true,
      visible: true,
    },
  ],
  columns: [],
  currentRecord: {
    oid: '',
    unidade: {},
    nome: '',
    numeroConvenioCobranca: '',
    codigoCarteiraCobranca: '',
    descricaoDocumento: '',
    especieDocumento: {},
    numeroParcelas: '',
    tipoPagamentoDivergente: {},
    valorMinimoPagamentoDivergente: '',
    enviarAvisoVencimentoSmsAntesVencimento: false,
    enviarAvisoVencimentoSmsDiaVencimento: false,
    enviarAvisoVencimentoSmsAposVencimento: false,
    tipoDesconto: {},
    valorDesconto: '',
    percentualDesconto: '',
    tipoMulta: {},
    valorMulta: '',
    percentualMulta: '',
    tipoJurosMora: {},
    valorJurosMora: '',
    percentualJurosMora: '',
    diasNegativacaoSerasa: '',
    diasProtesto: '',
    formaEmissao: {},
    tipoBoleto: {},
    numeroDocumento: '',
    dataEmissao: '',
    valorAbatimento: '',
    enviarAvisoVencimentoSms: '',
    tipoPessoaAvalista: '',
    reciboBeneficiario: false,
    indicadorRegistroCip: {},
    codigo: '',
    codigoBanco: '',
    codigoCooperativa: '',
    codigoTransmissao: '',
    nomeBanco: '',
    agencia: '',
    digitoAgencia: '',
    digitoConta: '',
    instrucoes: '',
    tipoCobranca: {},
    tipoProtesto: '',
    tipoDecursoProtesto: {},
    tipoPrazoDesconto: {},
    diasBaixa: '',
    diasJuros: '',
    diasMulta: '',
    diasDesconto: '',
    numeroContrato: '',
    diasLimitePagamento: '',
    gerarComQrcode: false,
    identificacaoBoletoAceito: '',
    formaEmissaoRemessa: {},
    tipoModalidadeCarteira: '',
    configDesconto: '',
    tipoChavePix: '',
    chavePix: '',
    workspaceId: '',
    tipoRetornoBoleto: {},
    acaoProtesto: '',
    configArquivoRetorno: {},
    posto: '',
    clientId: '',
    clientSecret: '',
    certificadoDigital: {},
    extensaoArquivoRetorno: '',
    identificadorReceitaFederalAvalista: '',
    nomeAvalista: '',
  },
  messages: null,
  selectedFilters: [],
  usaListDto: false,
}

const reducer = new Reducer(initialState, types)

export function CRUDConfiguracaoBoletoReducer(state, action) {
  if (state) {
    state.messages = storage.getAppLabels('configuracaoboleto')
  }
  state = reducer.execute(state, action)
  return execute(state, action)
}

function execute(state, action) {
  switch (action.type) {
    case types.RESET:
      return reset(state, action)
    case types.SET_BOOLEAN_FILTER:
      return setBooleanFilter(state, action)
    default:
      return state
  }
}

function reset(state, action) {
  return { ...state, currentRecord: initialState.currentRecord, records: [], selectedFilters: [] }
}

function setBooleanFilter(state, action) {
  let booleanFilter = Object.assign({}, state.booleanFilter)
  booleanFilter[action.field] = action.value
  return Object.assign({}, state, { booleanFilter })
}
